<template>
  <a-spin :tip="loadingTip" :spinning="isloading" class="cmswrapper">
    <div class="mainWrapper clearfix ruleInfo">
      <div class="articleMeauleft" :style="height">
        <a-divider orientation="left">题目分类</a-divider>
        <a-tree
          :replaceFields="replaceFields"
          :treeData="treeDataCategory"
          checkable
          @check="checkCategory"
        />
      </div>
      <div class="articleMainRight">
        <div class="pxkeji-right-box">
          <a-form :form="form" @submit="handleSubmit">
            <a-form-item label="单选题" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
              <a-row :gutter="15">
                <a-col :span="10">
                  <a-input-number
                    placeholder="题目数量"
                    :min="0"
                    :max="info.singleTotalCount"
                    v-decorator="[
              'singleCount',
              {rules: [{ required: false, message: '请输入题目数量!' }],initialValue:info.singleCount}
            ]"
                  ></a-input-number>
                  <span> / {{info.singleTotalCount}}</span>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item label="多选题" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
              <a-row :gutter="15">
                <a-col :span="10">
                  <a-input-number
                    placeholder="题目数量"
                    :min="0"
                    :max="info.multiTotalCount"
                    v-decorator="[
              'multiCount',
              {rules: [{ required: false, message: '请输入题目数量!' }],initialValue:info.multiCount}
            ]"
                  ></a-input-number>
                  <span> / {{info.multiTotalCount}}</span>
                </a-col>
              </a-row>
            </a-form-item>
            <a-form-item label="判断题" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
              <a-row :gutter="15">
                <a-col :span="10">
                  <a-input-number
                    placeholder="题目数量"
                    :min="0"
                    :max="info.judgeTotalCount"
                    v-decorator="[
              'judgeCount',
              {rules: [{ required: false, message: '请输入题目数量!' }],initialValue:info.judgeCount}
            ]"
                  ></a-input-number>

                  <span> / {{info.judgeTotalCount}}</span>
                </a-col>
              </a-row>
            </a-form-item>
            <!-- <a-form-item label="题目总数" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="题目总数"
              :disabled="true"
              v-decorator="[
          'totalCount',
          {rules: [{ required: false, message: '题目总数!' }],initialValue:info.totalCount}
        ]"
            ></a-input>
            </a-form-item>-->
            <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
              <pxkeji-btn name="抽题并保存" type="primary" htmlType="submit" />
              <pxkeji-btn name="取消" type="default" @click="cancelClick" style="margin-left:10px;" />
            </a-form-item>
          </a-form>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;

export default {
  props: {
    selList: Array
  },
  data() {
    return {
      form: this.$form.createForm(this),
      height: {
        height: ""
      },
      treeDataCategory: [],
      replaceFields: { children: "list", title: "name", key: "id" },
      info: {
        categoryId: [],
        totalCount: 0,
        singleTotalCount: 0,
        multiTotalCount: 0,
        judgeTotalCount: 0
      },
      isloading: false,
      loadingTip: "加载中...",
    };
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      this.getTree();
      this.getTypeCount();
    });
  },
  methods: {
    getTree() {
      this.$api.questioncategory
        .getTree()
        .then(res => {
          if (res.errorCode == this.$msg.responseCode.success) {
            res.data.forEach(function(item, index) {
              item.id = Number(item.id);
            });
            var tree = [
              {
                id: 0,
                name: "全部",
                list: res.data
              }
            ];
            this.treeDataCategory = tree;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    checkCategory(checkedKeys, e) {
      this.info.categoryId = [];
      for (var i = 0; i < checkedKeys.length; i++) {
        this.info.categoryId.push(checkedKeys[i]);
      }
      this.getTypeCount();
    },
    //试题数量
    getTypeCount() {
      this.$api.subject
        .getTypeCount(this.info.categoryId.join())
        .then(res => {
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info.singleTotalCount = 0;
            this.info.multiTotalCount = 0;
            this.info.judgeTotalCount = 0;
            res.data.forEach(function(item, index) {
              if (item.subject_type == 0) {
                that.info.singleTotalCount = parseInt(item.counts);
              } else if (item.subject_type == 1) {
                that.info.multiTotalCount = parseInt(item.counts);
              } else {
                that.info.judgeTotalCount = parseInt(item.counts);
              }
            });
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          //数据验证
          this.isloading = true;
          this.loadingTip = "保存中...";
          this.$api.subject
            .getRandomList(
              this.info.categoryId.join(),
              values.singleCount ? values.singleCount : 0,
              values.multiCount ? values.multiCount : 0,
              values.judgeCount ? values.judgeCount : 0
            )
            .then(res => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$emit("callbackMethod", res.data);
              } else {
                this.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.ant-cascader-menu {
  height: 320px;
}
.mainWrapper {
  box-sizing: border-box !important;
}
.ruleInfo .articleMeauleft {
  width: 40%;
  padding: 0 1%;
  min-height: 600px;
  background: #fff;
  float: left;
  margin-top: 24px;
}
.ruleInfo .articleMainRight {
  width: 60%;
  float: right;
}
</style>